import { __decorate } from "tslib";
import { LitElement, html, css, property, customElement } from "lit-element";
import { kode4CssTheme } from '@kode4/ui/kode4-css-theme';
import { v4 as uuidv4 } from "uuid";
let Kode4Growl = class Kode4Growl extends LitElement {
  constructor() {
    super(...arguments);
    this.messages = [];
  }
  alert(growlMessage) {
    if (!growlMessage.id) {
      growlMessage.id = `kode4growlmessage_${uuidv4()}`;
    }
    const id = growlMessage.id;
    this.messages = [
      ...this.messages,
      growlMessage
    ];
    if (growlMessage.timeout) {
      setTimeout(() => {
        this.closeMessage(id);
      }, growlMessage.timeout);
    }
  }
  closeMessage(id) {
    if (!id) {
      return;
    }
    this.messages = [
      ...this.messages.filter((el) => el.id !== id)
    ];
  }
  render() {
    return html`
            <div class="container">
                ${this.messages.map((msg) => html`
                    <div
                        class="message kode4-alert kode4-alert-hover ${msg.color ? `kode4-bg-${msg.color}` : ''}"
                        id="${msg.id}"
                        @click="${() => this.closeMessage(msg.id)}"
                        .innerHTML="${msg.message}"
                        >
                        
                    </div>
                `)}
            </div>
        `;
  }
  static get styles() {
    return css`
            ${kode4CssTheme}

            :host {
                position: fixed;
                z-index: 9000;
                bottom: 10px;
                right: 10px;
                width: 350px;
                max-width: 80vw;
            }

            .message {
                width: auto;
            }

            .message + .message {
                margin-top: 10px;
            }
        `;
  }
};
__decorate([
  property()
], Kode4Growl.prototype, "messages", void 0);
Kode4Growl = __decorate([
  customElement('kode4-growl')
], Kode4Growl);
export { Kode4Growl };
//# sourceMappingURL=kode4-growl.js.map